export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/c548b655198103f4512b5c31a526a1a1.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-7xl font-light text-white leading-tight">
                Secure Your
              </h1>
              <h1 className="text-7xl font-bold text-white leading-tight bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
                Digital Freedom
              </h1>
            </div>
            
            <p className="text-lg text-gray-300 leading-relaxed max-w-xl">
              Experience ultimate online privacy and security with ECJL VPN. Protect your data, browse anonymously, and access content freely from anywhere in the world.
            </p>

            <button
              onClick={scrollToContact}
              className="group px-8 py-4 bg-gradient-to-r from-cyan-400 to-cyan-500 text-white text-lg font-semibold rounded-full hover:shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 flex items-center space-x-3 whitespace-nowrap cursor-pointer"
            >
              <span>Get Protected</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/20 to-purple-600/20 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20and%20laptop%20displaying%20VPN%20security%20shield%20interface%20with%20glowing%20cyan%20and%20purple%20accents%2C%20floating%20in%20space%20with%20abstract%20encrypted%20data%20streams%20and%20connection%20nodes%2C%20clean%20minimalist%203D%20illustration%20showing%20digital%20protection%20and%20privacy%20technology%2C%20dark%20background%20with%20luminous%20effects&width=600&height=700&seq=hero-device-001&orientation=portrait"
                alt="VPN Security"
                className="relative rounded-3xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
